import { render } from "./RequestPasswordChangeKeyComponent.vue?vue&type=template&id=b434c480"
import script from "./RequestPasswordChangeKeyComponent.vue?vue&type=script&lang=js"
export * from "./RequestPasswordChangeKeyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__